import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '01',
  title: 'Bases de la Pastelería Desde Cero'
}, {
  num: '02',
  title: 'Tortas y Bizcochos Profesionales'
}, {
  num: '03',
  title: 'Pastelería para Emprender Desde Casa'
}, {
  num: '04',
  title: 'Postres y Dulces Más Vendidos'
}, {
  num: '05',
  title: 'Decoración y Presentación Profesional'
}, {
  num: '06',
  title: 'Maestría Pastelera y Crecimiento del Negocio'
}];
export function TomosSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-[#fff8f9]" data-id="element-215">
      <div className="max-w-5xl mx-auto" data-id="element-216">
        <div className="text-center mb-8" data-id="element-217">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-218">
            ♡ Contenido del MegaPack ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a]" data-id="element-219">
            ¿Qué incluye{' '}
            <span className="italic text-[#e89aaa]" data-id="element-220">el MegaPack?</span>
          </h2>
          <p className="text-base text-[#8b6f47] max-w-xl mx-auto mt-3" data-id="element-221">
            6 Tomos premium para llevarte de la pasión al negocio.
          </p>
        </div>

        <div ref={ref} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-5 ${isVisible ? 'is-visible' : ''}`} data-id="element-222">
          {TOMOS.map((tomo, i) => <div key={i} className="group relative bg-white rounded-3xl p-6 border border-[#f4b6c2]/30 shadow-[0_8px_30px_rgba(232,154,170,0.05)] hover:shadow-[0_20px_50px_rgba(232,154,170,0.12)] hover:-translate-y-1 transition-all duration-500" data-id="element-223">
              <div className="flex items-start gap-5" data-id="element-224">
                <div className="shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br from-[#fdf2f4] to-[#f8d7da] flex items-center justify-center font-serif italic text-2xl text-[#e89aaa] shadow-sm" data-id="element-225">
                  {tomo.num}
                </div>
                <div className="flex-1" data-id="element-226">
                  <span className="text-[#e89aaa] text-[10px] font-bold tracking-[0.25em] uppercase mb-2 block" data-id="element-227">
                    Tomo {tomo.num}
                  </span>
                  <h3 className="text-xl md:text-2xl font-serif font-bold text-[#6b4f3a] leading-tight" data-id="element-228">
                    {tomo.title}
                  </h3>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}